import { signOut } from "firebase/auth";
import { auth } from "firebaseConfig";

const Logout = () => {
    return (
        <li>
            <a
                href="./"
                onClick={async () => {
                    signOut(auth).then(() => {
                        window.location.href = "/";
                    });
                }}
            >
                Log out
            </a>
        </li>
    );
};

export default Logout;
